if (!window.__hizrturnVariantMediaSyncInitialized) {
  window.__hizrturnVariantMediaSyncInitialized = true;

  document.addEventListener('slideshow:select', (event) => {
    const detail = event.detail;
    if (!detail?.userInitiated || !detail.id) return;

    const slideshow = event.target;
    if (!(slideshow instanceof HTMLElement)) return;

    const gallery = slideshow.closest('media-gallery');
    if (!gallery) return;

    const mapElement = gallery.querySelector('script[data-variant-media-map]');
    if (!(mapElement instanceof HTMLScriptElement)) return;

    let variantIds = [];
    try {
      const entries = JSON.parse(mapElement.textContent || '[]');
      variantIds = entries
        .filter((entry) => String(entry.mediaId) === String(detail.id))
        .map((entry) => String(entry.variantId));
    } catch {
      return;
    }

    if (!variantIds.length) return;

    const section = gallery.closest('.shopify-section, dialog');
    const picker =
      section?.querySelector('variant-picker[data-template-product-match="true"]') ||
      section?.querySelector('variant-picker');
    if (!picker) return;

    const colorFieldset = Array.from(picker.querySelectorAll('fieldset')).find(
      (fieldset) => fieldset.dataset.optionName?.toLowerCase() === 'color'
    );
    if (!colorFieldset) return;

    const colorInput = Array.from(colorFieldset.querySelectorAll('input[data-variant-id]')).find(
      (input) => variantIds.includes(String(input.dataset.variantId))
    );

    if (colorInput instanceof HTMLInputElement && !colorInput.checked && !colorInput.disabled) {
      colorInput.click();
    }
  });
}